import { MODIFY_USER_PREFERENCE_SUCCESS, MODIFY_USER_PREFERENCE_FAIL } from '../constants/ActionTypes';

export default function modifyUserPreferencesError(state = false, { type }) {
    switch (type) {
        case MODIFY_USER_PREFERENCE_SUCCESS:
            return false;

        case MODIFY_USER_PREFERENCE_FAIL:
            return true;

        default:
            return state;
    }
}
